module.exports = __webpack_public_path__ + "img/Plan4.9ab3b9a5.jpg";